import React from 'react';

import { Typography, Step, StepLabel } from '@material-ui/core';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function Assist({ steps }) {
  const [active] = React.useState(0);
  const isMobile = window.innerWidth <= 425;

  return (
    <S.Wrapper
      activeStep={active}
      orientation={isMobile ? 'vertical' : 'horizontal'}
    >
      {steps.map((step) => {
        const labelProps = {};

        if (step.description) {
          labelProps.optional = (
            <Typography variant="caption">{step.description}</Typography>
          );
        }

        return (
          <Step key={step.title}>
            <StepLabel {...labelProps}>{step.resume || step.title}</StepLabel>
          </Step>
        );
      })}
    </S.Wrapper>
  );
}

Assist.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.any).isRequired,
};
